(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["framework--instagram"] && !window.DesignMode) return;
  try {
    
  async function generateInstagramGrid() {
  const endpoint = 'https://feeds.behold.so/9JNl7enEDQoA3fzQwdn3';
  const igGridDivs = document.querySelectorAll('.ig_grid');

  try {
    const response = await fetch(endpoint);
    const data = await response.json();
    

    function createGridItem(item) {
      const gridItem = document.createElement('div');
      gridItem.className = 'featured-grid--item';
      
      // Set styles for responsive square
      gridItem.style.width = '100%';
      gridItem.style.paddingBottom = '100%';  // Creates a 1:1 aspect ratio
      gridItem.style.position = 'relative';
      gridItem.style.overflow = 'hidden';
      gridItem.setAttribute('data-container', 'block');
      
      const content = document.createElement('div');
      content.style.position = 'absolute';
      content.style.top = '0';
      content.style.left = '0';
      content.style.width = '100%';
      content.style.height = '100%';
      
      content.innerHTML = `
        <a href="${item.permalink}" aria-label="Instagram" target="_blank" rel="noopener" style="
          display: block;
          width: 100%;
          height: 100%;
        ">
          <img src="${item.sizes.small.mediaUrl}" alt="Instagram post" style="
            width: 100%;
            height: 100%;
            object-fit: cover;
          ">
        </a>
      `;
      
      gridItem.appendChild(content);
      
      return gridItem;
    }

    igGridDivs.forEach(gridDiv => {
      var postLimit = parseInt(gridDiv.dataset.postLimit);
      data.posts.forEach(item => {
        if (postLimit > 0) {
          postLimit = postLimit - 1
        } else {
          return
        }
        var gridItem = createGridItem(item);
        gridDiv.appendChild(gridItem);
      });
    });

    
  } catch (error) {
    console.error('Error fetching Instagram data:', error);
  }
}
document.addEventListener('DOMContentLoaded', generateInstagramGrid);

  } catch(e) { console.error(e); }
})();
      })();
